import Vue from 'vue'

import { mountComponentTag } from '@/mounter'

import DotcomTooltip from './Tooltip'

Vue.component('SanitasLinkTooltip', DotcomTooltip)

mountComponentTag('tooltip', DotcomTooltip, {}, true)
